export function EditDocument (pEditor, pDocument)
{
  this.queryOpenEditDocumentDialogEnabled = (pButton, command) =>
  {
    var currentRange = pEditor.range.getCurrent();
    var checkParentTagA = /^a$/i;
    var attParams;
    var ret = false;

    var startParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, pEditor.checkAllBlockTagsPlusA);
    var endParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, pEditor.checkAllBlockTagsPlusA);
    var parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

    if (startParentBlockElement == endParentBlockElement && parentCurrentElement)
    {
      attParams = pButton.getAttribute('parameters');

      if (attParams && attParams.includeStrings &&
          (parentCurrentElement.href.toLowerCase().indexOf(attParams.includeStrings[0].toLowerCase()) != -1 ||
           parentCurrentElement.href.toLowerCase().indexOf(attParams.includeStrings[1].toLowerCase()) != -1))
      {
        ret = true;
      }
    }

    return ret;
  };
}